module.exports = {
  name: 'Marcel',
  roles: [
    'Computer Science Student',
    'Java + Android Developer',
    'React Apprentice',
  ],
  socialLinks: [
    {
      id: 'github',
      url: 'https://github.com/Marcel-Ebert',
      name: 'Find me on GitHub',
      fontAwesomeIcon: 'fab fa-github',
    },
    {
      id: 'linkedin',
      url: 'https://www.linkedin.com/in/marcel-ebert-198336166/',
      name: 'Find me on LinkedIn',
      fontAwesomeIcon: 'fab fa-linkedin',
    },
  ],
};
